import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReturnAgeOfCelebrantPipe} from "./return-age-of-celebrant.pipe";



@NgModule({
  declarations: [ReturnAgeOfCelebrantPipe],
  imports: [
    CommonModule
  ],
  exports: [
    ReturnAgeOfCelebrantPipe
  ]
})
export class ReturnAgeOfCelebrantModule { }
